<template>
  <div>
    <h3 @click="enableDebug($event)" class="display-4">Manage Quote</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :new-to="{ name: 'ocom_quote_old.create', params: { id: 0 } }"
      :query-select-options="options"
      :schema="schema"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      @reset_table="reset_table"
      new-button-text="New Quote"
    >
      <template slot="middle">
        <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        />
      </template>
    </o-list-toolbar>

    <b-table
      :fields="fields"
      :items="items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
      @row-selected="onRowSelected"
      @sort-changed="change_sort"
      bordered
      class="o-list"
      head-variant="light"
      no-local-sorting
      selectable
      striped
      thead-class="o-gradient-header"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template
        slot="top-row"
        slot-scope="{ columns, fields }"
        v-if="filterRow"
      >
        <td :key="field.key" class="p-0" v-for="field in fields">
          <span v-if="field.key === 'address_line1'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.address_line1"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'address_line2'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.address_line2"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'app_description'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.app_description"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'app_effort'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.app_effort"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'app_helps_with'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.app_helps_with"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'app_process_of'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.app_process_of"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'client'">
            <o-form-select
              :loading="optionOcomClientWorking"
              :options="optionOcomClientItems"
              @change="filter_changed"
              blank-option-text=""
              name="client"
              sort-field="name"
              text-field="name"
              v-model="list_options.qbe.client"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'quote_type'">
            <o-form-select
              :loading="optionCodeQuoteTypeWorking"
              :options="optionCodeQuoteTypeItems"
              @change="filter_changed"
              blank-option-text=""
              name="quote_type"
              sort-field="description"
              text-field="description"
              v-model="list_options.qbe.quote_type"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'company_name'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.company_name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'contact_name'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.contact_name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'created_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.created_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'include_hosting'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.include_hosting"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'lost_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              hide-time
              v-model="list_options.qbe.lost_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'markup_for_fast_tracked'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.markup_for_fast_tracked"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'modified_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.modified_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'modules'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.modules"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'monthly_hosting'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.monthly_hosting"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'non_project_hourly_rate'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.non_project_hourly_rate"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'project_hourly_rate'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.project_hourly_rate"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'project_name'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.project_name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'project_weekly_rate'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.project_weekly_rate"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'saas_markup'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.saas_markup"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'software_as_a_service'">
            <o-boolean-select
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.software_as_a_service"
            ></o-boolean-select>
          </span>
          <span v-if="field.key === 'warranty_period'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.warranty_period"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'won_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              hide-time
              v-model="list_options.qbe.won_date"
            ></o-flatpickr-wrapper>
          </span>
        </td>
      </template>
      <template slot="cell(address_line1)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'address_line1'"
        >
          <default-display :value="item.address_line1"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(address_line2)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'address_line2'"
        >
          <default-display :value="item.address_line2"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(app_description)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'app_description'"
        >
          <default-display :value="item.app_description"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(app_effort)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'app_effort'"
        >
          <default-display :value="item.app_effort"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(app_helps_with)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'app_helps_with'"
        >
          <default-display :value="item.app_helps_with"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(app_process_of)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'app_process_of'"
        >
          <default-display :value="item.app_process_of"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(client)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'client'"
        >
          <lookup-display
            :list="optionOcomClientItemsById"
            :value="item.client"
            default-value="-"
            display-field="name"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(company_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'company_name'"
        >
          <default-display :value="item.company_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(contact_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'contact_name'"
        >
          <default-display :value="item.contact_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(include_hosting)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'include_hosting'"
        >
          <boolean-display :value="item.include_hosting"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(lost_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'lost_date'"
        >
          <date-display
            :value="item.lost_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(markup_for_fast_tracked)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'markup_for_fast_tracked'"
        >
          <number-display :decimals="2" :value="item.markup_for_fast_tracked" />
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(modules)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'modules'"
        >
          <default-display :value="item.modules"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(monthly_hosting)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'monthly_hosting'"
        >
          <number-display :decimals="2" :value="item.monthly_hosting" />
        </o-link-cell>
      </template>
      <template
        slot="cell(non_project_hourly_rate)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'non_project_hourly_rate'"
        >
          <number-display :decimals="2" :value="item.non_project_hourly_rate" />
        </o-link-cell>
      </template>
      <template slot="cell(project_hourly_rate)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'project_hourly_rate'"
        >
          <number-display :decimals="2" :value="item.project_hourly_rate" />
        </o-link-cell>
      </template>
      <template slot="cell(project_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'project_name'"
        >
          <default-display :value="item.project_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(project_weekly_rate)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'project_weekly_rate'"
        >
          <number-display :decimals="2" :value="item.project_weekly_rate" />
        </o-link-cell>
      </template>
      <template slot="cell(quote_type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'quote_type'"
        >
          <lookup-display
            :list="optionCodeQuoteTypeItemsById"
            :value="item.quote_type"
            default-value="-"
            display-field="description"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(saas_markup)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'saas_markup'"
        >
          <number-display :decimals="2" :value="item.saas_markup" />
        </o-link-cell>
      </template>
      <template slot="cell(software_as_a_service)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'software_as_a_service'"
        >
          <boolean-display
            :value="item.software_as_a_service"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(warranty_period)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'warranty_period'"
        >
          <number-display :decimals="0" :value="item.warranty_period" />
        </o-link-cell>
      </template>
      <template slot="cell(won_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote_old.edit', params: { id: item.id } }"
          :when="first_column_key === 'won_date'"
        >
          <date-display
            :value="item.won_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'ocom_quote_old.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :offset="list_options.offset"
      :page-options="rows_per_page_items"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("OcomQuoteOld", "ocom_quote_old"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("OcomQuoteOld"),
    CreateCodeTableFetchMixin(["OcomClient", "CodeQuoteType"]),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.OcomQuoteOld,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.OcomQuoteOld),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        {
          name: "In Progress",
          code: "inprogress",
          options: { offset: 0, sort: "modified_date" },
        },
        { name: "Won!", code: "won", options: { offset: 0, sort: "won_date" } },
        {
          name: "Lost",
          code: "lost",
          options: { offset: 0, sort: "lost_date" },
        },

        {
          name: "Active",
          code: "active",
          options: { offset: 0, sort: "modified_date" },
        },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "modified_date" },
        },
        {
          name: "All",
          code: "all",
          options: { offset: 0, sort: "modified_date" },
        },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
    };
  },
  computed: {
    options() {
      return {
        OcomClient: {
          options: this.optionOcomClientItems,
          textField: "name",
          valueField: "id",
        },
        CodeQuoteType: {
          options: this.optionCodeQuoteTypeItems,
          textField: "description",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "project_name",
        "quote_type",
        "client",
        "created_date",
        "modified_date",
        "won_date",
        "lost_date",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>
